import React from 'react';
import { BrowserRouter } from 'react-router-dom';

// MSAL imports
import { MsalProvider } from "@azure/msal-react";
import { itIT } from '@mui/material/locale';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT as datePickersItIT } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import 'moment/locale/it';

import {
	FetchProvider,
	NavProvider,
	ToastProvider
} from './components/contexts';

import {
	Layout,
	Routes
} from './components/common';

import { SnackbarProvider } from 'notistack';
import { ApiProvider } from './components/contexts/ApiContext';
import { DataProvider } from './components/contexts/DataContext';

const theme = createTheme(
	{
		palette: {
			primary: {
				main: "#0059b3",
			},
			secondary: {
				main: "#036",
			},
		},
		typography: {
			fontFamily: '"Titillium Web",Geneva,Tahoma,sans-serif'
		},
	},
	itIT,
	datePickersItIT
);

function App(props) {
	return (
		<BrowserRouter basename={props.baseUrl}>
			<ThemeProvider theme={theme}>
				<LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="itIT">
					<SnackbarProvider preventDuplicate maxSnack={5}>
						<ToastProvider>
							<MsalProvider instance={props.pca}>
								<FetchProvider>
									<ApiProvider>
										<DataProvider>
											<NavProvider>
												<Layout>
													<Routes />
												</Layout>
											</NavProvider>
										</DataProvider>
									</ApiProvider>
								</FetchProvider>
							</MsalProvider>
						</ToastProvider>
					</SnackbarProvider>
				</LocalizationProvider>
			</ThemeProvider>
		</BrowserRouter>
	);
}

export default App;
